export default __webpack_public_path__ + "static/media/gruenden-nrw-podcast.c45c811c.png";